import { computed, ref, onBeforeUnmount } from 'vue'
import { useStore } from 'vuex'

const NETWORK_PLACEHOLDER = '{network}'

export default {
    name: 'PersonalFundraisingShareOverlay',
    setup() {
        const store = useStore()
        const showCopiedMessage = ref(false)
        let copiedTimeoutId = null

        const data = computed(() => store.state.main.page_overlay_content_data || {})

        const shareUrl = computed(() => data.value.shareUrl || '')
        const campaignUrl = computed(() => data.value.campaignUrl || '')
        const title = computed(() => data.value.title || '')
        const description = computed(() => data.value.description || '')
        const copyLinkLabel = computed(() => data.value.copyLinkLabel || 'Kopier link')
        const linkCopiedLabel = computed(
            () => data.value.linkCopiedLabel || 'Dit link er kopieret!'
        )
        const goToCollectionLabel = computed(
            () => data.value.goToCollectionLabel || 'Gå til indsamlingen'
        )

        const networkLabel = (network) => {
            const template = data.value.networkTemplate || `Del på ${NETWORK_PLACEHOLDER}`
            return template.replace(NETWORK_PLACEHOLDER, network)
        }

        const shareLinks = computed(() => {
            const encoded = encodeURIComponent(shareUrl.value)
            return [
                {
                    id: 'facebook',
                    label: networkLabel('Facebook'),
                    href: `https://www.facebook.com/sharer/sharer.php?u=${encoded}`,
                    target: '_blank',
                    rel: 'noopener noreferrer',
                    iconClass: 'kb-ui-icon--social-facebook'
                },
                {
                    id: 'x',
                    label: networkLabel('X'),
                    href: `https://twitter.com/intent/tweet?url=${encoded}`,
                    target: '_blank',
                    rel: 'noopener noreferrer',
                    iconClass: 'kb-ui-icon--social-x'
                },
                {
                    id: 'linkedin',
                    label: networkLabel('LinkedIn'),
                    href: `https://www.linkedin.com/sharing/share-offsite/?url=${encoded}`,
                    target: '_blank',
                    rel: 'noopener noreferrer',
                    iconClass: 'kb-ui-icon--social-linkedin'
                }
            ]
        })

        const copyShareLink = async () => {
            try {
                await navigator.clipboard.writeText(shareUrl.value)
                showCopiedMessage.value = true
                if (copiedTimeoutId) {
                    clearTimeout(copiedTimeoutId)
                }
                copiedTimeoutId = setTimeout(() => {
                    showCopiedMessage.value = false
                }, 2500)
            } catch (err) {
                console.error(err)
            }
        }

        onBeforeUnmount(() => {
            if (copiedTimeoutId) {
                clearTimeout(copiedTimeoutId)
            }
        })

        return {
            campaignUrl,
            copyLinkLabel,
            copyShareLink,
            description,
            goToCollectionLabel,
            linkCopiedLabel,
            shareLinks,
            showCopiedMessage,
            title
        }
    }
}
